module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "tool-panel"
  }, [_c('div', {
    staticClass: "tool-panel__block"
  }, [_c('h2', [_c('Icon', {
    attrs: {
      "icon": _vm.setFormIcon()
    }
  }), _vm._v(_vm._s(_vm.setFormTitle))], 1), _vm._v(" "), (_vm.setSavingsFutureData()) ? _c('div', {
    class: _vm.getToolClass('savingsFuture')
  }, [(_vm.isCurrentTool('savingsFuture')) ? _c('div', {
    staticClass: "tool__output"
  }, [_c('div', {
    staticClass: "tool__output-line"
  }, [_c('span', {
    staticClass: "tool__output-label"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.getSavingsFutureFrequencyLabel())
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "tool__output-value",
    domProps: {
      "innerHTML": _vm._s(_vm.getSavingsFutureContribution())
    }
  })]), _vm._v(" "), _c('Chart', {
    attrs: {
      "type": "bar",
      "data": _vm.getSavingsFutureData(),
      "id": "toolSavingsFutureChart",
      "width": "650",
      "height": "350"
    }
  }), _vm._v(" "), (_vm.showTable('savingsRequired')) ? _c('table', {
    staticClass: "toolTable"
  }, [_c('thead', [_c('tr', {
    staticClass: "toolTable__row"
  }, [_c('th', {
    staticClass: "toolTable__cell"
  }, [_vm._v(_vm._s(_vm._translate('tool.year')))]), _vm._v(" "), _c('th', {
    staticClass: "toolTable__cell"
  }, [_vm._v(_vm._s(_vm._translate('tool.regularDeposits')))]), _vm._v(" "), _c('th', {
    staticClass: "toolTable__cell"
  }, [_vm._v(_vm._s(_vm._translate('tool.totalInvested')))]), _vm._v(" "), _c('th', {
    staticClass: "toolTable__cell"
  }, [_vm._v(_vm._s(_vm._translate('tool.gain')))]), _vm._v(" "), _c('th', {
    staticClass: "toolTable__cell"
  }, [_vm._v(_vm._s(_vm._translate('tool.value')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.getSavingsFutureTableData()), function(item, index) {
    return _c('tr', {
      staticClass: "toolTable__row"
    }, [_c('td', {
      staticClass: "toolTable__cell"
    }, [_vm._v(_vm._s(item.year))]), _vm._v(" "), _c('td', {
      staticClass: "toolTable__cell"
    }, [_vm._v(_vm._s(_vm.formatCurrency(item.contribution)))]), _vm._v(" "), _c('td', {
      staticClass: "toolTable__cell"
    }, [_vm._v(_vm._s(_vm.formatCurrency(item.total)))]), _vm._v(" "), _c('td', {
      staticClass: "toolTable__cell"
    }, [_vm._v(_vm._s(_vm.formatCurrency(item.gain)))]), _vm._v(" "), _c('td', {
      staticClass: "toolTable__cell"
    }, [_vm._v(_vm._s(_vm.formatCurrency(item.value)))])])
  }))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isCurrentTool('savingsFuture')) ? _c('form', {
    staticClass: "tool__form"
  }, [_c('div', {
    staticClass: "tool__form-wrap"
  }, [_c('TextInput', {
    attrs: {
      "label": _vm._translate('tool.sumToAccumulate'),
      "type": "currency",
      "field": "tools.savingsFuture.sum"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "label": _vm._translate('tool.atRateOf'),
      "type": "percentage",
      "field": "tools.savingsFuture.rate"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "label": _vm._translate('tool.numberOfYears'),
      "type": "number",
      "field": "tools.savingsFuture.years"
    }
  }), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "label": _vm._translate('tool.Depositing'),
      "proto": "contributionFrequency",
      "field": "tools.savingsFuture.depositing"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox-wrap"
  }, [_c('input', {
    staticClass: "checkbox__input",
    attrs: {
      "id": "showSavingsRequired",
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.showTableChecked('savingsRequired')
    },
    on: {
      "change": function($event) {
        _vm.showTableUpdate('savingsRequired')
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label",
    attrs: {
      "for": "showSavingsRequired"
    }
  }, [_vm._v(_vm._s(_vm._translate('tool.showSummaryTable')))])])], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.setInvestmentFuture()) ? _c('div', {
    class: _vm.getToolClass('investmentFuture')
  }, [(_vm.isCurrentTool('investmentFuture')) ? _c('div', {
    staticClass: "tool__output"
  }, [_c('div', {
    staticClass: "tool__output-line"
  }, [_c('span', {
    staticClass: "tool__output-label"
  }, [_vm._v(_vm._s(_vm._translate('tool.futureValue')))]), _vm._v(" "), _c('span', {
    staticClass: "tool__output-value",
    domProps: {
      "innerHTML": _vm._s(_vm.getInvestmentFutureValue())
    }
  })]), _vm._v(" "), _c('Chart', {
    attrs: {
      "type": "bar",
      "data": _vm.getInvestmentFutureData(),
      "id": "toolInvestmentFutureDataChart",
      "width": "650",
      "height": "350"
    }
  }), _vm._v(" "), (_vm.showTable('futureValue')) ? _c('table', {
    staticClass: "toolTable"
  }, [_c('thead', [_c('tr', {
    staticClass: "toolTable__row"
  }, [_c('th', {
    staticClass: "toolTable__cell"
  }, [_vm._v(_vm._s(_vm._translate('tool.year')))]), _vm._v(" "), _c('th', {
    staticClass: "toolTable__cell"
  }, [_vm._v(_vm._s(_vm._translate('tool.regularDeposits')))]), _vm._v(" "), _c('th', {
    staticClass: "toolTable__cell"
  }, [_vm._v(_vm._s(_vm._translate('tool.totalContributions')))]), _vm._v(" "), _c('th', {
    staticClass: "toolTable__cell"
  }, [_vm._v(_vm._s(_vm._translate('tool.gain')))]), _vm._v(" "), _c('th', {
    staticClass: "toolTable__cell"
  }, [_vm._v(_vm._s(_vm._translate('tool.value')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.getInvestmentFutureTableData()), function(item, index) {
    return _c('tr', {
      staticClass: "toolTable__row"
    }, [_c('td', {
      staticClass: "toolTable__cell"
    }, [_vm._v(_vm._s(item.year))]), _vm._v(" "), _c('td', {
      staticClass: "toolTable__cell"
    }, [_vm._v(_vm._s(_vm.formatCurrency(item.contribute)))]), _vm._v(" "), _c('td', {
      staticClass: "toolTable__cell"
    }, [_vm._v(_vm._s(_vm.formatCurrency(item.contribution)))]), _vm._v(" "), _c('td', {
      staticClass: "toolTable__cell"
    }, [_vm._v(_vm._s(_vm.formatCurrency(item.gain)))]), _vm._v(" "), _c('td', {
      staticClass: "toolTable__cell"
    }, [_vm._v(_vm._s(_vm.formatCurrency(item.value)))])])
  }))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isCurrentTool('investmentFuture')) ? _c('form', {
    staticClass: "tool__form"
  }, [_c('div', {
    staticClass: "tool__form-wrap"
  }, [_c('TextInput', {
    attrs: {
      "label": _vm._translate('tool.initialInvestment'),
      "type": "currency",
      "field": "tools.investmentFuture.sum"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "label": _vm._translate('tool.growthRate'),
      "type": "percentage",
      "field": "tools.investmentFuture.rate"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "label": _vm._translate('tool.numberOfYears'),
      "type": "number",
      "field": "tools.investmentFuture.years"
    }
  }), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "label": _vm._translate('tool.Depositing'),
      "proto": "contributionFrequency",
      "field": "tools.investmentFuture.depositing"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "label": _vm._translate('tool.regularDeposits'),
      "type": "currency",
      "field": "tools.investmentFuture.contribution"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox-wrap"
  }, [_c('input', {
    staticClass: "checkbox__input",
    attrs: {
      "id": "showFutureValue",
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.showTableChecked('futureValue')
    },
    on: {
      "change": function($event) {
        _vm.showTableUpdate('futureValue')
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label",
    attrs: {
      "for": "showFutureValue"
    }
  }, [_vm._v(_vm._s(_vm._translate('tool.showSummaryTable')))])])], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.setRegularWithdrawals()) ? _c('div', {
    class: _vm.getToolClass('regularWithdrawals')
  }, [(_vm.isCurrentTool('regularWithdrawals')) ? _c('div', {
    staticClass: "tool__output"
  }, [_c('div', {
    staticClass: "tool__output-line"
  }, [_c('span', {
    staticClass: "tool__output-label"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.getRegularWithdrawalsFrequencyLabel())
    }
  }), _vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "tool__output-value",
    domProps: {
      "innerHTML": _vm._s(_vm.getRegularWithdrawalsWithdrawal())
    }
  })]), _vm._v(" "), _c('Chart', {
    attrs: {
      "type": "bar",
      "data": _vm.getRegularWithdrawalsData(),
      "id": "toolRegularWithdrawalsChart",
      "width": "650",
      "height": "350"
    }
  }), _vm._v(" "), (_vm.showTable('regularWithdrawals')) ? _c('p', {
    staticClass: "note"
  }, [_vm._v(_vm._s(_vm._translate('tool.withdrawlsFootnote')))]) : _vm._e(), _vm._v(" "), (_vm.showTable('regularWithdrawals')) ? _c('table', {
    staticClass: "toolTable"
  }, [_c('thead', [_c('tr', {
    staticClass: "toolTable__row"
  }, [_c('th', {
    staticClass: "toolTable__cell"
  }, [_vm._v(_vm._s(_vm._translate('tool.period')))]), _vm._v(" "), _c('th', {
    staticClass: "toolTable__cell"
  }, [_vm._v(_vm._s(_vm._translate('tool.withdrawal')))]), _vm._v(" "), _c('th', {
    staticClass: "toolTable__cell"
  }, [_vm._v(_vm._s(_vm._translate('tool.remainingBalance')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.getRegularWithdrawalsTableData()), function(item, index) {
    return _c('tr', {
      staticClass: "toolTable__row"
    }, [_c('td', {
      staticClass: "toolTable__cell"
    }, [_vm._v(_vm._s(item.year))]), _vm._v(" "), _c('td', {
      staticClass: "toolTable__cell"
    }, [_vm._v(_vm._s(_vm.formatCurrency(item.withdrawal)))]), _vm._v(" "), _c('td', {
      staticClass: "toolTable__cell",
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(item.balance))
      }
    })])
  }))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isCurrentTool('regularWithdrawals')) ? _c('form', {
    staticClass: "tool__form"
  }, [_c('div', {
    staticClass: "tool__form-wrap"
  }, [_c('TextInput', {
    attrs: {
      "label": _vm._translate('tool.initialValue'),
      "type": "currency",
      "field": "tools.regularWithdrawals.sum"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "label": _vm._translate('tool.atRateOf'),
      "type": "percentage",
      "field": "tools.regularWithdrawals.rate"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "label": _vm._translate('tool.numberOfYears'),
      "type": "number",
      "field": "tools.regularWithdrawals.years"
    }
  }), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "label": _vm._translate('tool.withdrawing'),
      "proto": "contributionFrequency",
      "field": "tools.regularWithdrawals.withdrawing"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "label": _vm._translate('tool.indexAt'),
      "type": "percentage",
      "field": "tools.regularWithdrawals.index"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox-wrap"
  }, [_c('input', {
    staticClass: "checkbox__input",
    attrs: {
      "id": "showRegularWithdrawals",
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.showTableChecked('regularWithdrawals')
    },
    on: {
      "change": function($event) {
        _vm.showTableUpdate('regularWithdrawals')
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label",
    attrs: {
      "for": "showRegularWithdrawals"
    }
  }, [_vm._v(_vm._s(_vm._translate('tool.showSummaryTable')))])])], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.setSystematicWithdrawals()) ? _c('div', {
    class: _vm.getToolClass('systematicWithdrawals')
  }, [(_vm.isCurrentTool('systematicWithdrawals')) ? _c('div', {
    staticClass: "tool__output"
  }, [_c('Chart', {
    attrs: {
      "type": "bar",
      "data": _vm.getSystematicWithdrawalsData(),
      "id": "toolSystematicWithdrawalsChart",
      "width": "650",
      "height": "350"
    }
  }), _vm._v(" "), (_vm.showTable('systematicWithdrawals')) ? _c('p', {
    staticClass: "note"
  }, [_vm._v(_vm._s(_vm._translate('tool.systematicWithdrawlsFootnote')))]) : _vm._e(), _vm._v(" "), (_vm.showTable('systematicWithdrawals')) ? _c('table', {
    staticClass: "toolTable"
  }, [_c('thead', [_c('tr', {
    staticClass: "toolTable__row"
  }, [_c('th', {
    staticClass: "toolTable__cell"
  }, [_vm._v(_vm._s(_vm._translate('tool.period')))]), _vm._v(" "), _c('th', {
    staticClass: "toolTable__cell"
  }, [_vm._v(_vm._s(_vm._translate('tool.withdrawal')))]), _vm._v(" "), _c('th', {
    staticClass: "toolTable__cell"
  }, [_vm._v(_vm._s(_vm._translate('tool.gain')) + "*")]), _vm._v(" "), _c('th', {
    staticClass: "toolTable__cell"
  }, [_vm._v(_vm._s(_vm._translate('tool.balance')) + "*")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.getSystematicWithdrawalsTableData()), function(item, index) {
    return _c('tr', {
      staticClass: "toolTable__row"
    }, [_c('td', {
      staticClass: "toolTable__cell"
    }, [_vm._v(_vm._s(item.period))]), _vm._v(" "), _c('td', {
      staticClass: "toolTable__cell"
    }, [_vm._v(_vm._s(_vm.formatCurrency(item.withdrawal)))]), _vm._v(" "), _c('td', {
      staticClass: "toolTable__cell",
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(item.gain))
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "toolTable__cell",
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(item.balance))
      }
    })])
  }))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isCurrentTool('systematicWithdrawals')) ? _c('form', {
    staticClass: "tool__form"
  }, [_c('div', {
    staticClass: "tool__form-wrap"
  }, [_c('TextInput', {
    attrs: {
      "label": _vm._translate('tool.initialValue'),
      "type": "currency",
      "field": "tools.systematicWithdrawals.sum"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "label": _vm._translate('tool.withdrawalAmount'),
      "type": "currency",
      "field": "tools.systematicWithdrawals.withdrawal"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "label": _vm._translate('tool.atRateOf'),
      "type": "percentage",
      "field": "tools.systematicWithdrawals.rate"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "label": _vm._translate('tool.numberOfYears'),
      "type": "number",
      "field": "tools.systematicWithdrawals.years"
    }
  }), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "label": _vm._translate('tool.withdrawing'),
      "proto": "contributionFrequency",
      "field": "tools.systematicWithdrawals.withdrawing"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkbox-wrap"
  }, [_c('input', {
    staticClass: "checkbox__input",
    attrs: {
      "id": "showSystematicWithdrawals",
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.showTableChecked('systematicWithdrawals')
    },
    on: {
      "change": function($event) {
        _vm.showTableUpdate('systematicWithdrawals')
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label",
    attrs: {
      "for": "showSystematicWithdrawals"
    }
  }, [_vm._v(_vm._s(_vm._translate('tool.showSummaryTable')))])])], 1)]) : _vm._e()]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3044d480!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ToolPanel.vue
// module id = 313
// module chunks = 0